import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

import { FullPageSpinner } from './Spinner';
import { FocusShell, FocusShellFailure } from './FocusShell';
import { Button } from './ui/button';
import { describeError } from '../lib/errors';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoading) {
    return <FullPageSpinner label="Signing you in…" />;
  }

  if (auth.error) {
    console.error('Authentication error:', auth.error);
    return (
      // The same failure Callback renders (FocusShellFailure): one full-width
      // primary, whatever the error's kind — signing in again is always the fix.
      <FocusShell title="Couldn't sign you in">
        <FocusShellFailure
          alertTitle="Sign-in failed"
          message={describeError(auth.error).message}
          action={
            <Button
              className="w-full"
              onClick={() => auth.signinRedirect({ state: { returnTo: location.pathname + location.search } })}
            >
              Sign in again
            </Button>
          }
        />
      </FocusShell>
    );
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
